/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { PendingNavigationResolver } from '@/components/pending-navigation-outlet';
import CategoryPendingShell from '.';

const CATEGORY_PATH_SEGMENT = /(?:^|\/)category(?:\/|$)/;

export function isCategoryPathNavigation(currentPathname: string, nextPathname: string): boolean {
    return nextPathname !== currentPathname && CATEGORY_PATH_SEGMENT.test(nextPathname);
}

export const resolveCategoryPendingNavigation: PendingNavigationResolver = ({ currentLocation, nextLocation }) =>
    isCategoryPathNavigation(currentLocation.pathname, nextLocation.pathname) ? <CategoryPendingShell /> : undefined;
